"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _react = _interopRequireDefault(require("react"));
var _client = require("react-dom/client");
var Sentry = _interopRequireWildcard(require("@sentry/react"));
var _App = _interopRequireDefault(require("../App"));
var _PaneErrorScreen = require("../components/PaneErrorScreen");
var _AnalyticsContext = require("../context/AnalyticsContext");
var _PageContext = require("../context/PageContext");
var _styledComponents = require("styled-components");
var _theme = _interopRequireDefault(require("../styles/theme"));
var _GlobalStyle = _interopRequireDefault(require("../styles/GlobalStyle"));
var _e2eTestHook = require("../utils/e2e-test-hook");
var _wopiSession = require("../utils/wopi/wopi-session");
var _environments = require("../utils/environments");
var _constants = require("../constants");
var _branding = require("../utils/branding");
var _longTaskReport = require("../utils/long-task-report");
var _sentryReporter = require("../utils/sentry-reporter");
require("../styles/globals.css");
require("katex/dist/katex.min.css");
var _jsxRuntime = require("react/jsx-runtime");
var _URLSearchParams$get;
/*
 * Copyright (c) Microsoft Corporation. All rights reserved. Licensed under the MIT license.
 * See LICENSE in the project root for license information.
 */
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t3 in e) "default" !== _t3 && {}.hasOwnProperty.call(e, _t3) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t3)) && (i.get || i.set) ? o(f, _t3, i) : f[_t3] = e[_t3]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var OFFICE_LOAD_TIMEOUT_MS = 15000;
var OFFICE_POLL_INTERVAL_MS = 100;
var DIOPTRA_WEB_APP_URL = "https://app.dioptra.ai";
var bootstrapRoot = null;

// The Icertis auth dialog box loads this same taskpane.html. A dialog box has no
// document host, so any Word.run call (e.g. WOPI's custom-property read) never
// resolves and hangs bootstrap on the loading screen. Detect the dialog pages and
// skip that work. Compare lowercased: Icertis lowercases the whole redirect URL it
// echoes back, so the callback leg returns as `page=icertiscallbackpage` (matching
// App.tsx's own case-insensitive routing); the auth leg is set by us as camelCase.
var bootPageParam = ((_URLSearchParams$get = new URLSearchParams(window.location.search).get("page")) !== null && _URLSearchParams$get !== void 0 ? _URLSearchParams$get : "").toLowerCase();
var inIcertisDialog = bootPageParam === "icertisauthpage" || bootPageParam === "icertiscallbackpage";
if (!inIcertisDialog) {
  (0, _AnalyticsContext.startTelemetry)();
  (0, _longTaskReport.startLongTaskReport)();
}
bootstrap().catch(function (err) {
  var _bootstrapRoot;
  Sentry.captureException(err, {
    level: "fatal"
  });
  (_bootstrapRoot = bootstrapRoot) === null || _bootstrapRoot === void 0 || _bootstrapRoot.render(/*#__PURE__*/(0, _jsxRuntime.jsx)(StatusScreen, {
    message: "An unexpected error occurred. Please reload."
  }));
});
function bootstrap() {
  return _bootstrap.apply(this, arguments);
}
function _bootstrap() {
  _bootstrap = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
    var root, info, wopi, envAlreadyApplied, _t, _t2;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          root = (0, _client.createRoot)(document.getElementById("root"));
          bootstrapRoot = root;
          root.render(/*#__PURE__*/(0, _jsxRuntime.jsx)(StatusScreen, {
            message: "Loading add-in\u2026",
            showSpinner: true
          }));
          _context.p = 1;
          _context.n = 2;
          return waitForOffice();
        case 2:
          if (_context.v) {
            _context.n = 3;
            break;
          }
          root.render(/*#__PURE__*/(0, _jsxRuntime.jsx)(StatusScreen, {
            message: "Microsoft Word failed to load the add-in. Please reload."
          }));
          return _context.a(2);
        case 3:
          _context.n = 4;
          return Office.onReady();
        case 4:
          info = _context.v;
          if (!(info.host == Office.HostType.Word)) {
            _context.n = 9;
            break;
          }
          if (localStorage.getItem("DIOPTRA_E2E_ENABLED") === "1") {
            (0, _e2eTestHook.installE2eTestHook)();
          }

          // Skip WOPI resolution in the dialog box: its Word.run-based property read
          // never resolves there and would hang bootstrap before the auth/callback page
          // renders. The dialog pages don't need WOPI/environment resolution.
          if (inIcertisDialog) {
            _context.n = 8;
            break;
          }
          _context.p = 5;
          _context.n = 6;
          return _wopiSession.wopiSession.resolve();
        case 6:
          // reads WOPI_MODE + ICI_URL/ICI_API_URL → matched env
          wopi = _wopiSession.wopiSession.getState();
          envAlreadyApplied = sessionStorage.getItem(_constants.DIOPTRA_WOPI_ENV_APPLIED) === "1";
          if (wopi.isWopi && wopi.environment && !envAlreadyApplied) {
            if ((0, _environments.applyEnvironment)(wopi.environment)) {
              sessionStorage.setItem(_constants.DIOPTRA_WOPI_ENV_APPLIED, "1");
              console.log("[wopi] applied environment overrides for ".concat(wopi.environment.id, " before React mounts"));
            } else {
              (0, _sentryReporter.reportMessage)("WOPI environment ".concat(wopi.environment.id, " did not persist; it will be reapplied on the next load"), {
                level: "warning",
                extra: {
                  component: "taskpane",
                  action: "apply_wopi_environment"
                }
              });
            }
          }
          _context.n = 8;
          break;
        case 7:
          _context.p = 7;
          _t = _context.v;
          (0, _sentryReporter.reportError)(_t, {
            level: "warning",
            extra: {
              component: "taskpane",
              action: "resolve_wopi_session"
            }
          }); // boot continues → manual picker
        case 8:
          root.render(/*#__PURE__*/(0, _jsxRuntime.jsx)(DioptraTaskpane, {}));
          return _context.a(2);
        case 9:
          root.render(/*#__PURE__*/(0, _jsxRuntime.jsx)(StatusScreen, {
            message: "Redirecting to ".concat((0, _branding.getBranding)().name, "\u2026"),
            showSpinner: true
          }));
          window.location.href = DIOPTRA_WEB_APP_URL;
          _context.n = 11;
          break;
        case 10:
          _context.p = 10;
          _t2 = _context.v;
          Sentry.captureException(_t2, {
            level: "fatal"
          });
          root.render(/*#__PURE__*/(0, _jsxRuntime.jsx)(StatusScreen, {
            message: "An unexpected error occurred. Please reload."
          }));
        case 11:
          return _context.a(2);
      }
    }, _callee, null, [[5, 7], [1, 10]]);
  }));
  return _bootstrap.apply(this, arguments);
}
function DioptraTaskpane() {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Sentry.ErrorBoundary, {
    fallback: /*#__PURE__*/(0, _jsxRuntime.jsx)(_PaneErrorScreen.PaneErrorScreen, {}),
    showDialog: true,
    beforeCapture: function beforeCapture(scope) {
      return scope.setLevel("fatal");
    },
    "data-sentry-element": "Sentry.ErrorBoundary",
    "data-sentry-component": "DioptraTaskpane",
    "data-sentry-source-file": "taskpane.tsx",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_PageContext.PageProvider, {
      "data-sentry-element": "PageProvider",
      "data-sentry-source-file": "taskpane.tsx",
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styledComponents.ThemeProvider, {
        theme: _theme.default,
        "data-sentry-element": "ThemeProvider",
        "data-sentry-source-file": "taskpane.tsx",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_GlobalStyle.default, {
          "data-sentry-element": "GlobalStyle",
          "data-sentry-source-file": "taskpane.tsx"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_App.default, {
          "data-sentry-element": "App",
          "data-sentry-source-file": "taskpane.tsx"
        })]
      })
    })
  });
}
function waitForOffice() {
  return _waitForOffice.apply(this, arguments);
}
function _waitForOffice() {
  _waitForOffice = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
    var deadline;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          deadline = Date.now() + OFFICE_LOAD_TIMEOUT_MS;
        case 1:
          if (isOfficeAvailable()) {
            _context2.n = 4;
            break;
          }
          if (!(Date.now() >= deadline)) {
            _context2.n = 2;
            break;
          }
          return _context2.a(2, false);
        case 2:
          _context2.n = 3;
          return delay(OFFICE_POLL_INTERVAL_MS);
        case 3:
          _context2.n = 1;
          break;
        case 4:
          return _context2.a(2, true);
      }
    }, _callee2);
  }));
  return _waitForOffice.apply(this, arguments);
}
function isOfficeAvailable() {
  var _Office;
  return typeof Office !== "undefined" && typeof ((_Office = Office) === null || _Office === void 0 ? void 0 : _Office.onReady) === "function";
}
function delay(ms) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, ms);
  });
}
function StatusScreen(_ref) {
  var message = _ref.message,
    showSpinner = _ref.showSpinner;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    style: statusScreenStyles.container,
    role: "status",
    "aria-live": "polite",
    "aria-atomic": "true",
    "data-sentry-component": "StatusScreen",
    "data-sentry-source-file": "taskpane.tsx",
    children: [showSpinner && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      style: statusScreenStyles.spinner,
      "aria-hidden": true
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
      style: statusScreenStyles.message,
      children: message
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("style", {
      children: spinnerKeyframes
    })]
  });
}
var statusScreenStyles = {
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100vh",
    padding: "24px",
    color: "#1f2937",
    textAlign: "center",
    gap: "16px"
  },
  spinner: {
    width: "32px",
    height: "32px",
    border: "3px solid #e5e7eb",
    borderTopColor: "var(--muted-foreground)",
    borderRadius: "50%",
    animation: "dioptra-spin 0.9s linear infinite"
  },
  message: {
    margin: 0,
    fontSize: "14px",
    lineHeight: 1.5,
    maxWidth: "320px"
  }
};
var spinnerKeyframes = "@keyframes dioptra-spin { to { transform: rotate(360deg); } }";